module.exports = __webpack_public_path__ + "img/local-offers.1cff47e2.jpeg";